import { render, staticRenderFns } from "./TableDeliverableItems.vue?vue&type=template&id=5bc2f179&scoped=true&"
import script from "./TableDeliverableItems.vue?vue&type=script&lang=js&"
export * from "./TableDeliverableItems.vue?vue&type=script&lang=js&"
import style0 from "./TableDeliverableItems.vue?vue&type=style&index=0&id=5bc2f179&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc2f179",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
